import { type HexColor, hexColor } from "../hex-color/hex-color";
import type { RGB } from "../rgba-color/rgb-color";
import type { RGBA } from "../rgba-color/rgba-color";

const rgbaToHex = (rgba: RGB | RGBA): HexColor => {
    const { red, green, blue } = rgba;
    const alpha = "alpha" in rgba ? (rgba.alpha ?? 1) : 1;
    const hex = (value: number) => value.toString(16).padStart(2, "0");
    const result = hexColor(
        `#${hex(red)}${hex(green)}${hex(blue)}${alpha === 1 || typeof alpha === "undefined" ? "" : hex(Math.round(alpha * 255))}`,
    );
    return result;
};

export { rgbaToHex };
